import { useState } from 'react'
import { Button, KIND, SIZE } from 'baseui/button'
import useHttp from '@/shared/hooks/useHttp'
import { useTranslation } from 'react-i18next'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import ModalExportLogsTable from './ModalExportLogsTable'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { Upload } from 'baseui/icon'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'

const ExportLogsComponent = () => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const { isAdmin, country } = useSelector(selectAuthData)
  const { export_logs_url: exportLogsUrl } = useSelector(selectPageConfigurationData)
  const { sendRequest, getConfig } = useHttp()
  const [logs, setLogs] = useState([])
  const closeModal = () => {
    setIsOpen(false)
  }
  const subscriptionLogsHandler = (response, statusCode) => {
    if (statusCode === 200 && response && response.length > 0) {
      setLogs(response)
    }
    setIsOpen(true)
  }
  const fetchSubscriptionLogs = () => {
    sendRequest(exportLogsUrl + '?lang=' + country, getConfig('GET'), subscriptionLogsHandler)
  }

  if (isAdmin === false) {
    return ''
  }

  return (
    <>
      <Button
        kind={KIND.secondary}
        size={SIZE.compact}
        endEnhancer={() => <Upload size={24} />}
        onClick={event => {
          event.preventDefault()
          fetchSubscriptionLogs()
        }}
      >
        {t('subscriptionForm:subscription_actions_module.export_logs.view_export_logs_button')}
      </Button>

      <Modal
        onClose={closeModal}
        isOpen={isOpen}
        size={SIZE.default}
        overrides={{
          Dialog: {
            style: {
              width: '80vw',
            },
          },
        }}
      >
        <ModalHeader>{t('subscriptionForm:subscription_actions_module.export_logs.modal_header')}</ModalHeader>
        <ModalBody style={{ flex: '1 1 0' }}>
          <ModalExportLogsTable data={logs} />
        </ModalBody>
        <ModalFooter>
          <ModalButton kind={KIND.primary} onClick={closeModal}>
            {t('subscriptionForm:subscription_actions_module.export_logs.modal_close_button')}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ExportLogsComponent
